// core version + navigation, pagination modules:
import Swiper from '../third-party/swiper';
// import Swiper and modules styles
import Pagination from '../third-party/swiper/modules/pagination.mjs';
import Navigation from '../third-party/swiper/modules/navigation.mjs';

// Selectors
const selector = {
  swiper: '.js-swiper-banner',
  carouselWrapper: '.js-swiper-banner .swiper-wrapper',
  swiperPagination: '.js-swiper-banner .swiper-pagination',
  carouselControlPrev: '.js-swiper-banner .js-list-control--prev',
  carouselControlNext: '.js-swiper-banner .js-list-control--next'
};

// Elements
let swiper;

function buildSwiperSlider(carousel) {
  const carouselUuid = carousel.dataset.carouselUuid || '';
  const carouselItemsMobile = carousel.dataset.itemsMobile || 2;
  const carouselItemsTablet = carousel.dataset.itemsTablet || 3;
  const carouselItemsDesktop = carousel.dataset.itemsDesktop || 4;
  // init Swiper:
  swiper = new Swiper(`[data-carousel-uuid="${carouselUuid}"]`, {
    modules: [Pagination, Navigation],
    loop: true,
    // If we need pagination
    pagination: {
      el: selector.swiperPagination,
      type: 'bullets',
      clickable: true,
      dynamicBullets: true
    },
    navigation: {
      enabled: true,
      nextEl: selector.carouselControlNext,
      prevEl: selector.carouselControlPrev
    },
    slidesPerView: carouselItemsMobile,
    breakpoints: {
      // when window width is >= 480px
      640: {
        slidesPerView: carouselItemsTablet
      },
      // when window width is >= 640px
      1200: {
        slidesPerView: carouselItemsDesktop
      }
    }
  });
}
export default () => {
  const listsOfBanners = document.querySelectorAll(selector.swiper) || [];
  listsOfBanners.forEach((carousel) => {
    buildSwiperSlider(carousel);
  });
};
